import { Data } from "@react-google-maps/api";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";

import { InputMask } from "primereact/inputmask";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import NepaliDatePicker2 from "./nepaliDatePicker";

import React, { useEffect, useState } from "react";
import { calculateAge, isValidDateForYYYYMMDD } from "../../helper/helper";
import { Controller, useForm } from "react-hook-form";
import { Calendar as CalendarAD } from "primereact/calendar";
import { useTranslation } from "react-i18next";

function isValidDate(date) {
  var regEx = /^\d{4}-\d{2}-\d{2}$/;
  if (!date.match(regEx)) return false; // Invalid format
  var d = new Date(date);
  var dNum = d.getTime();
  if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
  return d.toISOString().slice(0, 10) === date;
}

export function formatDate(date) {

  console.log("datedatedatedate:", date);
  let newDate = new Date(date + "GMT").getFullYear() + '-' + (("0" + (new Date(date + "GMT").getMonth() + 1)).slice(-2)) + '-' + ("0" + (new Date(date + "GMT").getDate())).slice(-2);

  console.log("newDatenewDatenewDatenewDatenewDate:", newDate);
  return newDate;
}
const AdBsDatePicker = (props) => {
  const { t, i18n } = useTranslation();
  const [dateError, setDateError] = useState();
  const [show, setShow] = useState(false);
  //const [adDate, setAdDate] = useState();
  //const [bsDate, setBsDate] = useState();
  //const [extra, setExtra] = useState();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  return (
    < >
      <div style={props.bsStyle} className={props.disableClassName ? "" :
        ("p-field " + (props.stickRight ? props.stickRight : "stick-right") + " " + (props.css ? props.css : "p-md-4"))}>
        <label className="p-col-12 p-md-12" >
          {props.bsLabel ? props.bsLabel : (props.label)}{t("bs")}{props.dateMetaData && props.dateMetaData.mandatory ? '*' : ''}
        </label>
        <span class="p-calendar p-component p-inputwrapper p-calendar-w-btn p-inputwrapper-filled">
          <NepaliDatePicker2
            show={show}
            inputClassName={"p-inputtext p-component"}
            placeholder={t("dateInBs")}
            onChange={(value) => {

              // props.dispatch(props.setterBs(value));
              //setBsDate(value);
              let bsDate = value;
              let adDate = null;
              const checkDate = isValidDateForYYYYMMDD(value);
              let date;
              try {
                date = bsToAd(value);
                if (new Date(date) > new Date() && !props.futureDate)
                  setDateError("Future date not allowed");
                else setDateError("");
              } catch (e) { }
              if (checkDate && date) {
                adDate = formatDate(date);

                if (adDate && bsDate) {
                  console.log("adDate:", adDate, "bsDate", bsDate);
                  props.onChange(adDate, bsDate);
                }
              }
            }
            }
            value={props.bsDate}
            disabled={props.disabled}
          />
          <button onClick={function (event) {
            setShow(Math.random());
          }} type="button" class="p-button p-component p-datepicker-trigger p-button-icon-only"

            disabled={props.disabled}>
            <i class="pi pi-calendar icon-front "></i>
          </button>
        </span>
        <span style={{ color: "red" }}>{dateError}</span>
        {props.getFormErrorMessageBs ? props.getFormErrorMessageBs : ''}
      </div>


      <div style={props.adStyle} className={props.disableClassName ? "" : ("p-field stick-left " + (props.stickRight ? props.stickRight : "stick-right") + " " + (props.css ? props.css : "p-md-4"))}>
        <label className="p-col-12 p-md-12" >
          {props.adLabel ? props.adLabel : (props.label)}{t("ad")}{props.dateMetaData && props.dateMetaData.mandatory ? '*' : ''}
        </label>

        <span className="p-input-icon-right">
          <i className="pi pi-calendar icon-front" />

          <CalendarAD
            showOnFocus={false}
            showIcon
            icon={
              <i className="pi pi-calendar icon-front " />}
            mask="9999-99-99"
            placeholder={t("dateInAd")}
            //readOnlyInput
            value={props.adDate && new Date(props.adDate)}
            onChange={(e) => {
              let dateValue = e.value;
              if (e.originalEvent && e.originalEvent.target && e.originalEvent.target.value && e.originalEvent.target.value.includes("_"))
                dateValue = null;
              // console.log("date ad check", e, dateValue, e.originalEvent.target.value);
              setDateError("");
              let adDate = null;
              let bsDate = null;
              let extra = null;
              if (!dateValue) { return; }
              try {

                const date = dateValue;
                if (date) {
                  // const convertedAdDate = adToBs(
                  //   date.toISOString().split("T")[0]
                  // );
                  const convertedAdDate = adToBs(
                    new Date(
                      date.getTime() - date.getTimezoneOffset() * 60000
                    )
                      .toISOString()
                      .split("T")[0]
                  );
                  adDate = formatDate(date);
                  bsDate = convertedAdDate;
                  if (adDate && bsDate) {
                    props.onChange(adDate, bsDate);
                  }
                }
              } catch (e) {
                alert("Date out of availability");
                console.log(e);
              }
            }}
            monthNavigator
            yearNavigator
            yearRange={props.futureDate ? "1900:3000" : "1900 : " + new Date().getFullYear()}
            dateFormat="yy-mm-dd"
            maxDate={props.futureDate ? '' : new Date()}
            minDate={props.pastDate ? new Date() : ''}
            disabled={props.disabled}
          />

        </span>
        <span style={{ color: "red" }}>{props.adError}</span>
        {props.getFormErrorMessageAd ? props.getFormErrorMessageAd : ''}
      </div>

    </>
  );
};

export default AdBsDatePicker;
